import { useEffect, useRef, useState } from "react";
import { itemAPI } from "../../api/itemAPI";

export default function ItemTypeSearch({ setItemCode, setItemName, pCode, setIsAllItemChecked }) {
    const [allItems, setAllItems] = useState([]);

    const isFirstRender = useRef(false);


    const getItems = (searchKey = '') => {
        itemAPI.getItems(pCode, searchKey).then((data) => {
            setAllItems(data);
        })
    }

    const handleRowSelect = (code, name) => {
        setItemCode(code);
        setItemName(name);
        setIsAllItemChecked(false);
    }

    useEffect(() => {
        if (!isFirstRender.current) {
            isFirstRender.current = true;
            getItems()
        }
    }, [])

    return (
        <div className="modal fade" id="itemTypeSearch" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Item</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                        <input type="text" className="form-control" placeholder="Search by code or name"
                            onChange={(e) => getItems(e.target.value)} />
                        <table className="table mt-1">
                            <thead className="thead--color">
                                <tr>
                                    <th scope="col">Code</th>
                                    <th scope="col">Name</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allItems && allItems.map(data => (
                                    <tr key={data.itemCode}>
                                        <td>{data.itemCode}</td>
                                        <td>{data.description}</td>
                                        <td className="text-center"><button type="button" className="btn btn-sm btn-dark"
                                            onClick={() => handleRowSelect(data.itemCode, data.description)} data-bs-dismiss="modal">
                                            Select</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}